module.exports = __webpack_public_path__ + "static/pattern-color_block.32f18674.svg";